var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .st0{fill:none;stroke:#A6B5DC;stroke-width:0.1;stroke-miterlimit:10;}\n   ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5,52.6l4.3,5.1c0.8,0.9,2.2,1.1,3.1,0.3l34.5-28.9c1.4-1.2,3.7-1.2,5.1,0L87,58c0.9,0.8,2.3,0.7,3.1-0.3l4.3-5.1  c0.8-0.9,0.7-2.3-0.3-3.1L52.6,14.5c-1.4-1.2-3.7-1.2-5.1,0L5.8,49.5C4.9,50.2,4.7,51.7,5.5,52.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5,80.5l4.3,5.1c0.8,0.9,2.2,1.1,3.1,0.3l34.5-28.9c1.4-1.2,3.7-1.2,5.1,0L87,85.9c0.9,0.8,2.3,0.7,3.1-0.3l4.3-5.1  c0.8-0.9,0.7-2.3-0.3-3.1L52.6,42.4c-1.4-1.2-3.7-1.2-5.1,0L5.8,77.3C4.9,78.1,4.7,79.5,5.5,80.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpArrows);
export default __webpack_public_path__ + "static/media/icon-up-arrows.87bf1911b8c03ff05893e0b102eb508e.svg";
export { ForwardRef as ReactComponent };